import { Resource } from 'ia-react-core';
import React, { FC } from 'react';
import getPromotionsApiRoot from '../../utils/getPromotionsApiRoot';
import { PromotionDto } from '../../interfaces/PromotionDto';
import transformPromotions from './transformPromotions';

export interface PromotionLoaderProps { }

const PromotionLoader: FC<PromotionLoaderProps> = () => (
  <Resource
    name="/App.features.notifications.promotionsResource"
    url={`${getPromotionsApiRoot()}/promotions`}
    dataDst="/App.features.notifications.promotions"
    transformResponse={(promotionDto: PromotionDto[]) => transformPromotions(promotionDto)}
    autoRequest
    requestOnLanguageChange
  />
);

export default PromotionLoader;
